import { MasterCrud } from '@/components/MasterCrud';
import { Input } from '@/components/ui/Input';
import { endpoints } from '@/api/endpoints';

interface CategoryRow {
  id: number;
  name: string;
  parent_id?: number | null;
  products_count?: number;
}
interface CategoryForm {
  name: string;
}

export function CategoriesPage() {
  return (
    <MasterCrud<CategoryRow, CategoryForm>
      title="Categories"
      description="Group your products. New brands and categories are auto-created on bulk import too."
      listUrl={endpoints.categories}
      itemUrl={endpoints.category}
      queryKey="categories"
      newForm={() => ({ name: '' })}
      toForm={(r) => ({ name: r.name })}
      toBody={(f) => ({ name: f.name.trim() })}
      // The backend returns a tree under `data` — flatten parents + children.
      pluck={(resp) => {
        const data = (resp as { data?: unknown })?.data ?? resp;
        const list = Array.isArray(data) ? data : [];
        const flat: CategoryRow[] = [];
        for (const p of list as CategoryRow[]) {
          flat.push(p);
          const children = (p as unknown as { children?: CategoryRow[] }).children;
          if (Array.isArray(children)) flat.push(...children);
        }
        return flat;
      }}
      columns={[
        {
          key: 'name',
          header: 'Name',
          cell: (r) => (
            <span className={r.parent_id ? 'pl-6 text-ink-soft' : 'font-medium'}>
              {r.parent_id ? '↳ ' : ''}
              {r.name}
            </span>
          ),
        },
        {
          key: 'products',
          header: 'Products',
          className: 'text-right',
          cell: (r) => r.products_count ?? 0,
        },
      ]}
      formFields={(value, setValue) => (
        <Input
          name="name"
          label="Category name"
          autoFocus
          value={value.name}
          onChange={(e) => setValue({ ...value, name: e.target.value })}
          placeholder="e.g. Sofas"
        />
      )}
    />
  );
}
